export const CUSTOMER_DATA_TO_GET_ORDER = 'customerDataToGetOrder';
